// src/features/visit/visitSelectionSlice.ts
import { RootState } from "@core/store"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface VisitSelectionState {
  selectedVisitUuid: string | null
}

const initialState: VisitSelectionState = {
  selectedVisitUuid: null,
}

const visitSelectionSlice = createSlice({
  name: "visitSelection",
  initialState,
  reducers: {
    setSelectedVisitUuid: (state, action: PayloadAction<string | null>) => {
      state.selectedVisitUuid = action.payload
    },
    clearSelectedVisitUuid: (state) => {
      state.selectedVisitUuid = null
    },
  },
})

export const { setSelectedVisitUuid, clearSelectedVisitUuid } =
  visitSelectionSlice.actions
export default visitSelectionSlice.reducer

export const visitSelector = (state: RootState) =>state.visitSelection.selectedVisitUuid
 
